const PIXI = require('pixi.js');
import {ResourcesStorage} from './ResourcesStorage';
import {FetchSingleResource} from './FetchSingleResource';

// LOAD IMAGES, TEXTURES AND SPRITES

// LOADING
function _setupLoading(loader, input) {
    return new Promise(resolve => {
        if (!input || (typeof input !== 'string' && !(input instanceof Array))) resolve(null);

        loader.add(input);
        resolve(input);
    });
}

function _load(loader, doThat) {
    return new Promise(resolve => {
        if (!doThat) resolve(null);

        loader.load((loader, resources) => {
            resolve(resources);
        });
    });
}

function _storeLoadedResources(storage, resources) {
    return new Promise(resolve => {
        if (!resources) resolve(null);

        let p;
        for (p in resources) {
            if (!resources.hasOwnProperty(p)) continue;
            if (!resources[p].error) {
                storage.add(p, resources[p]);
            }
        }
        resolve(resources);
    });
}

/* ------- */

// LOADING PROGRESS
function _addProgressTracking(progressTracker, loader, doThat) {
    return new Promise(resolve => {
        if (!doThat) resolve(null);
        if (typeof progressTracker !== 'function') resolve(doThat);

        // loader.onProgress.add(progressTracker);
        loader.on('progress', progressTracker);
        resolve(doThat);
    });
}

function _removeAllProgressTracking(loader, doThat) {
    return new Promise(resolve => {
        if (!doThat) resolve(null);
        loader.onProgress.detachAll();

        resolve(doThat);
    });
}
/* ----- */

// LOADER CONFIG

function _configLoader(loader, doThat) {
    return new Promise(resolve => {
        if (!doThat) resolve(null);

        const baseUrl = doThat.baseUrl || doThat.path;
        loader.baseUrl = baseUrl || '';
        resolve(doThat.manifest);
    });
}
/* ----- */

// LOADER RESET

function _reset(loader, doThat) {
    return new Promise(resolve => {
        if (!doThat) resolve(null);

        loader.reset();
        resolve(doThat);
    });
}
/* ----- */

// LOADING RESULT CHECKING
function _checkIfAtLeastOneFileLoaded(resources) {
    return new Promise(resolve => {
        if (!resources) {
            resolve(null);
            return;
        }

        let p;
        for (p in resources) {
            if (!resources.hasOwnProperty(p)) continue;
            if (!resources[p].error) {
                resolve(resources);
                return;
            }
        }
        resolve(null);
    });
}
/* ----- */

/*
 *     Manifest:
 *
 *     'http://...'
 *
 *     // object syntax
 *     {
 *         name: 'key2',
 *         url: 'http://...'
 *     }
 *     {
 *         url: 'http://...'
 *     }
 *     {
 *         name: 'key3',
 *         url: 'http://...'
 *         onComplete: function () {}
 *     }
 *     {
 *         url: 'https://...',
 *         onComplete: function () {},
 *         crossOrigin: true
 *     }
 *
 *     // you can also pass an array of objects or urls or both
 *     [
 *         { name: 'key4', url: 'http://...', onComplete: function () {} },
 *         { url: 'http://...', onComplete: function () {} },
 *         'http://...'
 *     ]
 *
 */

function PIXIPreload(manifest, config, doThat, progressUpdate, store = false, storage = null) {
    const _storage = storage || ResourcesStorage.instance();

    return new Promise((resolve, reject) => {
        if (!doThat || !manifest) {
            resolve(doThat);
            return;
        }

        //
        // DEFAULT:
        // The number of resources to load concurrently.
        PIXI.loader.concurrency = 5;

        // CONFIG
        if (config) {
            if (config.concurrency) PIXI.loader.concurrency = config.concurrency;
        }

        const __preloadManifestData = doThat => {
            return FetchSingleResource(false, doThat, false, doThat, void 0, false);
        };

        const __configLoader = (function(loader) {
            return doThat => {
                return _configLoader(loader, doThat);
            };
        })(PIXI.loader);

        const __reset = (function(loader) {
            return doThat => {
                return _reset(loader, doThat);
            };
        })(PIXI.loader);

        const __setupLoad = (function(loader) {
            return input => {
                return _setupLoading(loader, input);
            };
        })(PIXI.loader);

        const __progressTracker =
            typeof progressUpdate === 'function'
                ? loader => {
                      progressUpdate(loader.progress / 100, loader);
                  }
                : void 0;

        const __addProgressTracking = function(loader, doThat) {
            return _addProgressTracking(__progressTracker, loader, doThat);
        };

        const __trackProgress = (function(loader) {
            return doThat => {
                return __addProgressTracking(loader, doThat);
            };
        })(PIXI.loader);

        const __stopAllTrackProgress = (function(loader) {
            return doThat => {
                return _removeAllProgressTracking(loader, doThat);
            };
        })(PIXI.loader);

        const __load = (function(loader) {
            return doThat => {
                return _load(loader, doThat);
            };
        })(PIXI.loader);

        const __storeLoadedResources = (function(storage) {
            return doThat => {
                return _storeLoadedResources(storage, doThat);
            };
        })(_storage);

        let promise =
            typeof manifest === 'object' && manifest.url && manifest.type && manifest.type === 'manifest'
                ? __preloadManifestData(manifest.url)
                      .then(__configLoader)
                      .then(__reset)
                : __configLoader(manifest instanceof Array ? {manifest: manifest} : manifest).then(__reset);

        promise = promise
            .then(__setupLoad)
            .then(__trackProgress)
            .then(__load);

        if (store) {
            promise = promise.then(__storeLoadedResources);
        }

        promise
            .then(__stopAllTrackProgress)
            .then(_checkIfAtLeastOneFileLoaded)
            .then(resources => {
                if (resources) resolve(resources);
                else reject();
            });
    });
}

export {PIXIPreload};
export default PIXIPreload;
